import React, { Component } from "react";
import queryString from "query-string";

// app header
import AppHeader from "../components/AppHeader/AppHeader";

// seo
import Seo from "../components/Seo";

// hook
import { useBookPackQuery } from "../hooks/useBookPackQuery";
import { useWindowSize } from "../hooks/useWindowSize";

// constant
import constant from "../constants";

// utils
import { splitName, splitPlanCodeBookPack } from "../utils";

// services
import { sendToCT } from "../services/Clevertap";
import { sendToLSQ } from "../services/LeadSquared";

// email
import { sendEmailNotifecation } from "../services/SendEmail";

// componentts
import BookPackHeading from "../components/BookPack/BookPackHeading";
import BookPackPilotForm from "../components/BookPack/BookPackPilotForm";
import FooterTerms from "../components/Footer/FooterTerms";

// api actions
import {
  handlePaymentOfBookPack,
  initiateSession,
} from "../actions/bookPackActions";
import OtpModal from "../components/BookPack/OtpModal";

class BookPackPilotEnterprise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      serverError: "",
      otpModal: {
        show: false,
        mobileNumber: "",
        pendingPaymentBody: null,
        pendingLsqParams: null,
      },
      type: "DIRECT_M2_ANNUAL",
      planCode: "",
      planPrice: 0,
      coupon: "",
      couponApplied: false,
      couponStatus: "",
      clintInfo: {},
      annualPlanPrice: 0,
      selectedPlan: "annualPlan",
      productId: "",
      installmentPlanPrice: 0,
      firstInstallmentPrice: 0,
      quarterlyPlanPrice: 0,
      monthlyPlanPrice: 0,
      toggleButtonValue: "pilot_diabetes",
      medicalDisorderType: "DIABETES",
      annualOfferPrice: 0,
      installmentOfferPrice: 0,
      quarterlyOfferPrice: 0,
      monthlyOfferPrice: 0,
    };
  }

  componentDidMount() {
    const annualPlan = this.props.bookPack.pilot_diabetes.annualPlan[0];
    const installmentPlan =
      this.props.bookPack.pilot_diabetes.installmentPlan[0];
    const quarterlyPlan = this.props.bookPack.pilot_diabetes.quarterlyPlan[0];
    const monthlyPlan = this.props.bookPack.pilot_diabetes.monthlyPlan[0];

    let plan = null;
    if (this.state.selectedPlan === "installmentPlan") {
      plan = installmentPlan;
    } else if (this.state.selectedPlan === "quarterlyPlan") {
      plan = quarterlyPlan;
    } else if (this.state.selectedPlan === "monthlyPlan") {
      plan = monthlyPlan;
    } else {
      plan = annualPlan;
    }

    const annualPlanData = splitPlanCodeBookPack(annualPlan);
    const installmentPlanData = splitPlanCodeBookPack(installmentPlan);
    const quarterlyPlanData = splitPlanCodeBookPack(quarterlyPlan);
    const monthlyPlanData = splitPlanCodeBookPack(monthlyPlan);

    plan &&
      this.setState({
        planCode: annualPlanData[0],
        planPrice: Number(annualPlanData[1]),
        planDay: plan.planDay,
        productId: plan.productId,
        annualPlanPrice: Number(annualPlanData[1]),
        installmentPlanPrice: Number(installmentPlanData[1]),
        firstInstallmentPrice: Number(installmentPlanData[2]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        annualOfferPrice: Number(
          this.props.bookPack.pilot_diabetes.annualPlan[0].offerPrice
        ),
        installmentOfferPrice: Number(
          this.props.bookPack.pilot_diabetes.installmentPlan[0].offerPrice
        ),
        quarterlyOfferPrice: Number(
          this.props.bookPack.pilot_diabetes.quarterlyPlan[0].offerPrice
        ),
        monthlyOfferPrice: Number(
          this.props.bookPack.pilot_diabetes.monthlyPlan[0].offerPrice
        ),
      });
  }

  // Function -> To handle the payment of book pack
  handlePayNow = async values => {
    const languageArr = [];
    if (values.language && values.language !== "") {
      values.language.map(item => {
        languageArr.push(item.name);
        return languageArr;
      });
    }

    // util function -> to split the name
    const { firstName, lastName } = splitName(values.name);

    // leadSquared params
    let leadSquaredParams = {
      FirstName: firstName,
      LastName: lastName,
      Phone: values.phone,
      EmailAddress: values.email,
      mx_Website_CTA: "book_pack_pilot",
      mx_Latest_Source: "New Website",
    };

    let subscriptionType = "";
    if (this.state.selectedPlan === "annualPlan") {
      subscriptionType = "YEARLY";
    } else if (this.state.selectedPlan === "installmentPlan") {
      subscriptionType = "HALF_YEARLY";
    } else if (this.state.selectedPlan === "quarterlyPlan") {
      subscriptionType = "QUARTERLY";
    } else if (this.state.selectedPlan === "monthlyPlan") {
      subscriptionType = "MONTHLY";
    }

    // payment v3
    let paymentBody = {
      firstName: firstName,
      lastName: lastName,
      mobileNumber: values.phone,
      email: values.email,
      planCode: this.state.planCode,
      preferredM2Plan: this.state.type,
      m1PlanCode: this.state.planCode,
      m2PlanCode: this.state.planCode,
      sourceType: "DIGITAL_ORGANIC_TW",
      couponCode: this.state.coupon ? this.state.coupon.toUpperCase() : "",
      languageList: languageArr,
      medicalDisorderType: this.state.medicalDisorderType,
      subscriptionType: subscriptionType,
      address: {
        postalCode: values.pinCode ? values.pinCode : "",
        city: values.city,
        line1: "",
      },
    };

    try {
      this.setState({ loading: true, serverError: "" });

      const sessionResult = await initiateSession(
        leadSquaredParams,
        values.phone
      );

      if (sessionResult.leadFound) {
        this.setState({
          loading: false,
          otpModal: {
            show: true,
            mobileNumber: values.phone,
            pendingPaymentBody: paymentBody,
            pendingLsqParams: leadSquaredParams,
          },
        });
        return;
      }

      const response = await handlePaymentOfBookPack(paymentBody);
      const paymentUrl = response.results[0].url;

      this.setState({ loading: false });
      window.location.href = paymentUrl;

      // clevertap event
      sendToCT("Enrollment Initiated", {
        action: "BookPack_Buy_Now Clicked",
        name: values.name,
        phone: values.phone,
        email: values.email,
        pincode: values.pinCode,
        coupon: this.state.coupon,
        paymentPlan: this.state.planCode,
      });
    } catch (error) {
      // send an email
      sendEmailNotifecation(
        window.location.href,
        paymentBody,
        error || {},
        "/marketing/v3/prospect"
      );

      console.error("payment api server error", error);
      this.setState({
        loading: false,
        serverError: constant.BOOKPACK_ERROR_MESSAGES.serverError,
      });
    }
  };

  handleOtpVerified = async () => {
    const { pendingPaymentBody, pendingLsqParams } = this.state.otpModal;
    this.setState({
      otpModal: { ...this.state.otpModal, show: false },
      loading: true,
      serverError: "",
    });
    try {
      await sendToLSQ({ ...pendingLsqParams, mx_OTP_Verified: "True" });
    } catch (e) {
      console.error("[handleOtpVerified] LSQ update failed:", e.message);
    }
    try {
      const response = await handlePaymentOfBookPack(pendingPaymentBody);
      const paymentUrl = response.results[0].url;
      this.setState({ loading: false });
      window.location.href = paymentUrl;
    } catch (error) {
      sendEmailNotifecation(
        window.location.href,
        pendingPaymentBody,
        error || {},
        "/marketing/v3/prospect"
      );
      console.error("payment api server error", error);
      this.setState({
        loading: false,
        serverError: constant.BOOKPACK_ERROR_MESSAGES.serverError,
      });
    }
  };

  handleOtpResend = async () => {
    const { pendingLsqParams, mobileNumber } = this.state.otpModal;
    if (pendingLsqParams && mobileNumber) {
      await initiateSession(pendingLsqParams, mobileNumber);
    }
  };

  // This function executes when we apply coupon
  handleCouponUpdate = (planPrice, coupon, discountAmt) => {
    if (coupon) {
      this.setState({
        showConfetti: true,
        planPrice: Number(planPrice),
        coupon: coupon,
        couponApplied: true,
      });

      // update plan price of selected plan after coupon applied
      if (this.state.selectedPlan === "installmentPlan") {
        this.setState({
          installmentPlanPrice: Number(planPrice),
          firstInstallmentPrice:
            Number(this.state.firstInstallmentPrice) - Number(discountAmt),
        });
      } else if (this.state.selectedPlan === "quarterlyPlan") {
        this.setState({ quarterlyPlanPrice: Number(planPrice) });
      } else if (this.state.selectedPlan === "monthlyPlan") {
        this.setState({ monthlyPlanPrice: Number(planPrice) });
      } else {
        this.setState({ annualPlanPrice: Number(planPrice) });
      }

      setTimeout(
        function () {
          this.setState({ showConfetti: false });
        }.bind(this),
        5000
      );
    }
  };

  // This function executes when we remove the applied coupon
  removedCoupon = () => {
    const annualPlanData = splitPlanCodeBookPack(
      this.props.bookPack[this.state.toggleButtonValue].annualPlan[0]
    );
    const installmentData = splitPlanCodeBookPack(
      this.props.bookPack[this.state.toggleButtonValue].installmentPlan[0]
    );

    const quarterlyPlanData = splitPlanCodeBookPack(
      this.props.bookPack[this.state.toggleButtonValue].quarterlyPlan[0]
    );

    const monthlyPlanData = splitPlanCodeBookPack(
      this.props.bookPack[this.state.toggleButtonValue].monthlyPlan[0]
    );

    if (this.state.selectedPlan === "installmentPlan") {
      this.setState({
        couponApplied: false,
        coupon: "",
        installmentPlanPrice: Number(installmentData[1]),
        firstInstallmentPrice: Number(installmentData[2]),
      });
    } else if (this.state.selectedPlan === "quarterlyPlan") {
      this.setState({
        couponApplied: false,
        coupon: "",
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
      });
    } else if (this.state.selectedPlan === "monthlyPlan") {
      this.setState({
        couponApplied: false,
        coupon: "",
        monthlyPlanPrice: Number(monthlyPlanData[1]),
      });
    } else {
      this.setState({
        couponApplied: false,
        coupon: "",
        annualPlanPrice: Number(annualPlanData[1]),
      });
    }
  };

  // Function -> Handle radio button plan cards
  handlePlan = val => {
    const annualPlanData = splitPlanCodeBookPack(
      this.props.bookPack[this.state.toggleButtonValue].annualPlan[0]
    );
    const installmentData = splitPlanCodeBookPack(
      this.props.bookPack[this.state.toggleButtonValue].installmentPlan[0]
    );

    const quarterlyPlanData = splitPlanCodeBookPack(
      this.props.bookPack[this.state.toggleButtonValue].quarterlyPlan[0]
    );

    const monthlyPlanData = splitPlanCodeBookPack(
      this.props.bookPack[this.state.toggleButtonValue].monthlyPlan[0]
    );

    const selectedPlanData = splitPlanCodeBookPack(
      this.props.bookPack[this.state.toggleButtonValue][val][0]
    );

    let planCode = "";
    let planPrice = "";

    if (val === "installmentPlan") {
      planCode = installmentData[0];
      planPrice = Number(installmentData[1]);
    } else if (val === "quarterlyPlan") {
      planCode = quarterlyPlanData[0];
      planPrice = Number(quarterlyPlanData[1]);
    } else if (val === "monthlyPlan") {
      planCode = monthlyPlanData[0];
      planPrice = Number(monthlyPlanData[1]);
    } else {
      planCode = annualPlanData[0];
      planPrice = Number(annualPlanData[1]);
    }

    this.setState({
      selectedPlan: val,
      planCode: planCode,
      planPrice: planPrice,
      firstInstallmentPrice: Number(installmentData[2]),
    });

    // when coupon applied and user changes the plan, update plan price of previous plan selected to original plan price
    if (this.state.couponApplied === true && val === "annualPlan") {
      this.setState({
        couponApplied: false,
        coupon: "",
        installmentPlanPrice: Number(installmentData[1]),
        firstInstallmentPrice: Number(installmentData[2]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        planCode: selectedPlanData[0],
      });
    } else if (this.state.couponApplied === true && val === "installmentPlan") {
      this.setState({
        couponApplied: false,
        coupon: "",
        annualPlanPrice: Number(annualPlanData[1]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        planCode: selectedPlanData[0],
      });
    } else if (this.state.couponApplied === true && val === "quarterlyPlan") {
      this.setState({
        couponApplied: false,
        coupon: "",
        annualPlanPrice: Number(annualPlanData[1]),
        installmentPlanPrice: Number(installmentData[1]),
        firstInstallmentPrice: Number(installmentData[2]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        planCode: selectedPlanData[0],
      });
    } else {
      this.setState({
        couponApplied: false,
        coupon: "",
        annualPlanPrice: Number(annualPlanData[1]),
        installmentPlanPrice: Number(installmentData[1]),
        firstInstallmentPrice: Number(installmentData[2]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        planCode: selectedPlanData[0],
      });
    }
  };

  // Handle toggle button functionality
  handleToggleButton = value => {
    // Handle price & plancode for Diabetes toggle button
    if (value === "pilot_diabetes") {
      const annualPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_diabetes.annualPlan[0]
      );
      const installmentPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_diabetes.installmentPlan[0]
      );

      const quarterlyPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_diabetes.quarterlyPlan[0]
      );

      const monthlyPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_diabetes.monthlyPlan[0]
      );

      this.setState({
        planCode: annualPlanData[0],
        planPrice: Number(annualPlanData[1]),
        annualPlanPrice: Number(annualPlanData[1]),
        installmentPlanPrice: Number(installmentPlanData[1]),
        firstInstallmentPrice: Number(installmentPlanData[2]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        toggleButtonValue: value,
        selectedPlan: "annualPlan",
        medicalDisorderType: "DIABETES",
        coupon: "",
        couponApplied: false,
        annualOfferPrice: Number(
          this.props.bookPack.pilot_diabetes.annualPlan[0].offerPrice
        ),
        installmentOfferPrice: Number(
          this.props.bookPack.pilot_diabetes.installmentPlan[0].offerPrice
        ),
        quarterlyOfferPrice: Number(
          this.props.bookPack.pilot_diabetes.quarterlyPlan[0].offerPrice
        ),
        monthlyOfferPrice: Number(
          this.props.bookPack.pilot_diabetes.monthlyPlan[0].offerPrice
        ),
      });
    } else if (value === "pilot_obesity") {
      // Handle price & plancode for Obesity toggle button
      const annualPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_obesity.annualPlan[0]
      );
      const installmentPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_obesity.installmentPlan[0]
      );

      const quarterlyPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_obesity.quarterlyPlan[0]
      );

      const monthlyPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_obesity.monthlyPlan[0]
      );

      this.setState({
        planCode: annualPlanData[0],
        planPrice: Number(annualPlanData[1]),
        annualPlanPrice: Number(annualPlanData[1]),
        installmentPlanPrice: Number(installmentPlanData[1]),
        firstInstallmentPrice: Number(installmentPlanData[2]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        toggleButtonValue: value,
        selectedPlan: "annualPlan",
        medicalDisorderType: "OBESITY",
        coupon: "",
        couponApplied: false,
        annualOfferPrice: Number(
          this.props.bookPack.pilot_obesity.annualPlan[0].offerPrice
        ),
        installmentOfferPrice: Number(
          this.props.bookPack.pilot_obesity.installmentPlan[0].offerPrice
        ),
        quarterlyOfferPrice: Number(
          this.props.bookPack.pilot_obesity.quarterlyPlan[0].offerPrice
        ),
        monthlyOfferPrice: Number(
          this.props.bookPack.pilot_obesity.monthlyPlan[0].offerPrice
        ),
      });
    } else if (value === "pilot_pre_diabetes") {
      // Handle price & plancode for Pre-Diabetes toggle button
      const annualPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_pre_diabetes.annualPlan[0]
      );
      const installmentPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_pre_diabetes.installmentPlan[0]
      );

      const quarterlyPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_pre_diabetes.quarterlyPlan[0]
      );

      const monthlyPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_pre_diabetes.monthlyPlan[0]
      );

      this.setState({
        planCode: annualPlanData[0],
        planPrice: Number(annualPlanData[1]),
        annualPlanPrice: Number(annualPlanData[1]),
        installmentPlanPrice: Number(installmentPlanData[1]),
        firstInstallmentPrice: Number(installmentPlanData[2]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        toggleButtonValue: value,
        selectedPlan: "annualPlan",
        medicalDisorderType: "PRE_DIABETES",
        coupon: "",
        couponApplied: false,
        annualOfferPrice: Number(
          this.props.bookPack.pilot_pre_diabetes.annualPlan[0].offerPrice
        ),
        installmentOfferPrice: Number(
          this.props.bookPack.pilot_pre_diabetes.installmentPlan[0].offerPrice
        ),
        quarterlyOfferPrice: Number(
          this.props.bookPack.pilot_pre_diabetes.quarterlyPlan[0].offerPrice
        ),
        monthlyOfferPrice: Number(
          this.props.bookPack.pilot_pre_diabetes.monthlyPlan[0].offerPrice
        ),
      });
    } else if (value === "pilot_metabolic_wellness") {
      // Handle price & plancode for Pre-Diabetes toggle button
      const annualPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_metabolic_wellness.annualPlan[0]
      );
      const installmentPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_metabolic_wellness.installmentPlan[0]
      );

      const quarterlyPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_metabolic_wellness.quarterlyPlan[0]
      );

      const monthlyPlanData = splitPlanCodeBookPack(
        this.props.bookPack.pilot_metabolic_wellness.monthlyPlan[0]
      );

      this.setState({
        planCode: annualPlanData[0],
        planPrice: Number(annualPlanData[1]),
        annualPlanPrice: Number(annualPlanData[1]),
        installmentPlanPrice: Number(installmentPlanData[1]),
        firstInstallmentPrice: Number(installmentPlanData[2]),
        quarterlyPlanPrice: Number(quarterlyPlanData[1]),
        monthlyPlanPrice: Number(monthlyPlanData[1]),
        toggleButtonValue: value,
        selectedPlan: "annualPlan",
        medicalDisorderType: "PRE_DIABETES",
        coupon: "",
        couponApplied: false,
        annualOfferPrice: Number(
          this.props.bookPack.pilot_metabolic_wellness.annualPlan[0].offerPrice
        ),
        installmentOfferPrice: Number(
          this.props.bookPack.pilot_metabolic_wellness.installmentPlan[0]
            .offerPrice
        ),
        quarterlyOfferPrice: Number(
          this.props.bookPack.pilot_metabolic_wellness.quarterlyPlan[0]
            .offerPrice
        ),
        monthlyOfferPrice: Number(
          this.props.bookPack.pilot_metabolic_wellness.monthlyPlan[0].offerPrice
        ),
      });
    }
  };

  render() {
    const {
      annualPlanPrice,
      clintInfo,
      loading,
      productId,
      planPrice,
      planDay,
      selectedPlan,
      serverError,
      installmentPlanPrice,
      firstInstallmentPrice,
      toggleButtonValue,
      quarterlyPlanPrice,
      monthlyPlanPrice,
      annualOfferPrice,
      installmentOfferPrice,
      quarterlyOfferPrice,
      monthlyOfferPrice,
    } = this.state;

    const { appHeader } = queryString.parse(this.props.location.search);

    return (
      <div className="bgLightgray" style={{ minHeight: "92vh" }}>
        <Seo
          title="Reverse Diabetes, Obesity & PMOS Naturally with Twin Health in India"
          description="Experience clinically proven, AI-driven program to reverse Diabetes, Hypertension, Obesity, PMOS & other chronic conditions with Twin Health now in India. 97% reduced blood sugar & medication, 98% symptom relief. Start your journey today."
        />

        {appHeader === "mobile" && <AppHeader text="BOOK PACK" isBack={true} />}

        {/* Heading */}
        <BookPackHeading />

        {/* Form */}
        <BookPackPilotForm
          price={planPrice}
          handlePayNow={this.handlePayNow}
          loading={loading}
          handleCouponUpdate={this.handleCouponUpdate}
          coupon={this.state.coupon}
          removedCoupon={this.removedCoupon}
          selectedPlan={selectedPlan}
          name={clintInfo.name}
          email={clintInfo.email}
          phone={clintInfo.phone}
          postalCode={clintInfo.postalCode}
          locationSearch={this.props.location.search}
          productId={productId}
          annualPlanPrice={annualPlanPrice}
          planDay={planDay}
          showCouponSection={true}
          windowSize={this.props.windowSize}
          couponType="bookpackCoupon"
          leadSquaredParam="book_pack_pilot"
          handlePlan={this.handlePlan}
          installmentPlanPrice={installmentPlanPrice}
          firstInstallmentPrice={firstInstallmentPrice}
          handleToggleButton={this.handleToggleButton}
          toggleButtonValue={toggleButtonValue}
          quarterlyPlanPrice={quarterlyPlanPrice}
          monthlyPlanPrice={monthlyPlanPrice}
          annualOfferPrice={annualOfferPrice}
          installmentOfferPrice={installmentOfferPrice}
          quarterlyOfferPrice={quarterlyOfferPrice}
          monthlyOfferPrice={monthlyOfferPrice}
          couponMessageType="enterpriseMsg"
          showAnnualCard={true}
          showInstallmentCard={true}
          showQuarterly={true}
          showMonthly={false}
        />
        <OtpModal
          show={this.state.otpModal.show}
          mobileNumber={this.state.otpModal.mobileNumber}
          onVerified={this.handleOtpVerified}
          onClose={() =>
            this.setState({ otpModal: { ...this.state.otpModal, show: false } })
          }
          onResend={this.handleOtpResend}
        />
        <div className="pb-5 text-center text-danger bgLightBlue">
          {serverError} &nbsp;
        </div>
        <div>
          <FooterTerms isHome={false} />
        </div>
      </div>
    );
  }
}

const WithContext = props => {
  const bookPackPayloadDiabetes = useBookPackQuery("enterprise_diabetes");
  const bookPackPayloadObesity = useBookPackQuery("enterprise_obesity");
  const bookPackPayloadPreDiabetes = useBookPackQuery(
    "enterprise_pre_diabetes"
  );
  const bookPackPayloadMetabolicWellness = useBookPackQuery(
    "enterprise_metabolic_wellness"
  );
  const windowSize = useWindowSize();

  const finalBookPackPayload = {
    pilot_diabetes: bookPackPayloadDiabetes,
    pilot_obesity: bookPackPayloadObesity,
    pilot_pre_diabetes: bookPackPayloadPreDiabetes,
    pilot_metabolic_wellness: bookPackPayloadMetabolicWellness,
  };

  return (
    <BookPackPilotEnterprise
      {...props}
      bookPack={finalBookPackPayload}
      windowSize={windowSize}
    />
  );
};

export default WithContext;
